// Local static fallback pool
export const MOTIVATIONAL_QUOTES = [
  {
    id: "local_q1",
    type: "text_bg",
    setId: "set_1",
    orderIndex: 1,
    text: "మిమ్మల్ని మీరు ఎవరితోనూ పోల్చుకోవద్దు. ఎందుకంటే, ప్రతి పుష్పానికి విభిన్నమైన సువాసన ఉంటుంది.",
    backgroundImage: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=800"
  }
];

let loadedQuotesPool = [...MOTIVATIONAL_QUOTES];

const cleanString = (str) => {
    if (!str) return '';
    return str.replace(/^"+|"+$/g, '').trim();
};

export const syncQuotesFromFirestore = (firestoreQuotesList) => {
    if (!firestoreQuotesList || firestoreQuotesList.length === 0) {
        loadedQuotesPool = [...MOTIVATIONAL_QUOTES];
        return;
    }
    
    loadedQuotesPool = firestoreQuotesList.map(item => ({
        id: item.id,
        type: item.type || 'text_bg',
        setId: item.setId || 'set_1',
        orderIndex: typeof item.orderIndex === 'number' ? item.orderIndex : 0, // Extract database sorting metric
        text: cleanString(item.Text || item.text),
        backgroundImage: cleanString(item.backgroundImage || item.background),
        quoteImage: cleanString(item.quoteImage || ''),
        author: cleanString(item.author || '')
    }));
};

/**
 * Organizes cards inside their Sets, sorts them ascending by orderIndex, and serves them to the feed [3]
 */
export const getSessionUniqueQuotes = (totalNewsInjected) => {
    const pool = loadedQuotesPool.length > 0 ? loadedQuotesPool : MOTIVATIONAL_QUOTES;
    
    const setsMap = {};
    pool.forEach(q => {
        const setId = q.setId || 'set_1';
        if (!setsMap[setId]) setsMap[setId] = [];
        setsMap[setId].push(q);
    });

    // Sort each set's array by orderIndex ascending
    Object.keys(setsMap).forEach(setId => {
        setsMap[setId].sort((a, b) => (a.orderIndex || 0) - (b.orderIndex || 0));
    });

    const setKeys = Object.keys(setsMap).sort();
    if (setKeys.length === 0) return [];

    const selectedSetKey = setKeys[totalNewsInjected % setKeys.length];
    return setsMap[selectedSetKey];
};